<template>
    <input 
    @change="onChange" 
    @input="onInput"
    type="text" 
    :placeholder="placeholder"/>
</template>

<script>
export default {
  props: {
    placeholder: {},
    onChange: {
      type: Function,
      default: () => null,
    },
    onInput: {
      type: Function,
      default: () => null,
    }
  }
}
</script>

<style scoped>
</style>